import getCharacteristicPrefixes from "../helpers/getCharacteristicPrefixes";
//--------------------------
// is characteristic prefix
//--------------------------
export default function isCharacteristicPrefix(pfx) {
  let char_array = getCharacteristicPrefixes()
  let match = char_array.find((c) => c == pfx)
  return match
}
